<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-08-23 18:28 -->
<!-- Description:  -->
<template>
  <select class="custom-select" v-model="selectedType" @change="$emit('input', selectedType)">
    <option value="">Seleccionar tipo</option>
    <option value="1">PAGO_DOCTOR</option>
    <option value="2">PAGO_PROVEEDOR</option>
    <option value="10">PAGO_EMPLEADO</option>
  </select>
</template>
<script>
export default {
  name: "LiquidationTypeSelect",
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data: () => ({
    selectedType: ''
  }),
  watch: {
    value(newVal) {
      this.selectedType = newVal
    }
  },
  mounted() {
    this.selectedType = this.value
  }
};
</script>
<style scoped></style>

